import { create } from "../../../common/utils/zustand_state_manager";
import { ReportsService } from "../../../features/reports/data/services/reports_service_impl";
import { IReportsService } from "../../../features/reports/data/services/reports_service";


/**
 * useReportsServices
 */

type State = {
  reportsService: IReportsService,
};

export const useReportsServices = create<State>((set, get) => ({
  reportsService: new ReportsService(),
}));